import React from 'react';

function ConfigureStep(props: ConfigureStepProps): JSX.Element {
  return (
    <div className="configureStep-container">
      <div className="configureStep-header">
        <div className="configureStep-step">{props.stepNumber}</div>
        <div className="configureStep-title">{props.title}</div>
      </div>
      <div>{props.children}</div>
    </div>
  );
}

interface ConfigureStepProps {
  stepNumber: number;
  title: string;
  children: Array<JSX.Element> | JSX.Element | null;
}

export default ConfigureStep;
